import moment from 'moment'

import { formatPrice } from '../../../../utils/common'
import styles from './Tooltip.module.scss'

const CustomTooltip = ({
  bookingCountToCharge,
  totalBookingValueToCharge,
  totalBookingValueNotCharged,
  bookingCountNotCharged,
  deliveredOn,
  isVisible
}) => {
  if (isVisible) {
    return (
      <div className={styles.tooltip}>
        {bookingCountNotCharged + bookingCountToCharge > 0 && (
          <div className={styles.row}>
            <span className={styles.value}>
              {bookingCountToCharge} bookings to charge
            </span>
            <span className={styles.label}>
              %
              {Math.floor(
                (bookingCountToCharge * 100) /
                  (bookingCountNotCharged + bookingCountToCharge)
              )}{' '}
              of all bookings
            </span>
          </div>
        )}
        {bookingCountNotCharged + bookingCountToCharge > 0 && (
          <div className={styles.row}>
            <span className={styles.value}>
              {formatPrice(totalBookingValueToCharge)} of booking value
            </span>
            <span className={styles.label}>
              %
              {Math.floor(
                (totalBookingValueToCharge * 100) /
                  (totalBookingValueToCharge + totalBookingValueNotCharged)
              )}{' '}
              of all bookings
            </span>
          </div>
        )}

        {deliveredOn ? (
          <div className={styles.row}>
            <span className={styles.label}>
              Delivered on {moment(deliveredOn).format('MMM DD')}
            </span>
          </div>
        ) : (
          <div className={styles.row}>
            <span style={{ color: '#ff4545' }} className={styles.value}>
              Not delivered
            </span>
          </div>
        )}
      </div>
    )
  }
  return null
}

export default CustomTooltip
